import React from 'react';
import classNames from 'classnames/bind';
import { MediaGalleryItem } from 'taboola-ultimate-ui';
import { CREATIVE_TYPE } from '../../../../config';
import EMPTY_FIELD_VALUE from '../../config/defaultValues';
import { EllipsisCellRenderer } from './index';
import styles from './dynamicReportMediaCellRenderer.module.scss';

const classNameBuilder = classNames.bind(styles);

const getFileType = col => col?.cellRendererParams?.values?.find(detail => detail.key === 'content_type');

export const DynamicReportMediaCellRenderer = props => {
    const { value, colDef } = props;
    const fileType = getFileType(colDef);
    if (value && fileType) {
        const thumbNailFileType = fileType.value === CREATIVE_TYPE.IMAGE ? 'image' : 'video';
        const thumbnail = { value, fileType: thumbNailFileType };

        return (
            <div className={classNameBuilder('cell-renderer-container')}>
                <MediaGalleryItem
                    imgSrc={value}
                    thumbnail={thumbnail}
                    showLargePreview
                    shouldAddOverlay={false}
                    imagePreviewRatio={8}
                    playVideoOnHover={false}
                />
            </div>
        );
    }
    return <EllipsisCellRenderer value={value || EMPTY_FIELD_VALUE} />;
};
